<div class="custom-table">
  <table>
    <thead>
      <tr>
        <th scope="col" [hidden]="!tableSelected['PRODUCT NAME']">
          PRODUCT NAME
        </th>
        <th scope="col" [hidden]="!tableSelected['PLAN/ PROGRAM NAME']">
          PLAN/PROGRAM NAME
        </th>
        <th scope="col" [hidden]="!tableSelected['STATUS']">STATUS</th>
        <th scope="col">
          <app-setting-dropdown
            [tableOptions]="tableOptions"
            [tableName]="tableName"
            (ChoosedOptions)="handleOutput($event)"
          ></app-setting-dropdown>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!isLoading && ratesList.length">
      <tr *ngFor="let rate of ratesList">
        <td data-thead="PRODUCT NAME" [hidden]="!tableSelected['PRODUCT NAME']">
          {{ rate?.product?.label | allLettersCapital : true }}
        </td>
        <td
          data-thead="PLAN/PROGRAM NAME"
          [hidden]="!tableSelected['PLAN/ PROGRAM NAME']"
        >
          <ng-container *ngFor="let plan of rate?.plan; let index = index">
            {{ (plan?.name?.en ?? plan?.name) | allLettersCapital : true
            }}{{ index === rate.plan?.length - 1 ? "" : "," }}
          </ng-container>
        </td>
        <td data-thead="STATUS" [hidden]="!tableSelected['STATUS']">
          {{ rate?.status | allLettersCapital : true }}
        </td>
        <td data-thead="ACTIONS">
          <div class="rate-actions">
            <button
              type="button"
              class="rate-action-btn"
              routerLink="{{ redirectUrl }}{{ rate?.id }}"
              title="Edit rate"
            >
              <img
                class="edit-icon"
                src="../../../../assets/images/ic-edit.png"
                alt="edit-icon"
              />
            </button>
            <button
              *ngIf="canDelete"
              type="button"
              class="rate-action-btn"
              title="Delete rate"
              (click)="handleDelete(rate)"
            >
              <img
                class="delete-icon"
                src="../../../../assets/images/trash2.svg"
                alt="delete-icon"
              />
            </button>
          </div>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="isLoading">
      <tr *ngFor="let item of schemaLoading">

        <td data-thead="PRODUCT NAME">
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        </td>

        <td data-thead="PLAN/PROGRAM NAME">
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        </td>

        <td data-thead="STATUS">
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        </td>
        <td data-thead="ACTIONS">
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <!-- no data -->
    <tbody *ngIf="!isLoading && ratesList.length === 0">
      <tr>
        <td colspan="12" class="no-data">There Is No Data At The Moment</td>
      </tr>
    </tbody>
  </table>
</div>
<app-paginator
  *ngIf="!isLoading && totalItems"
  [rowsPerPage]="10"
  [total]="totalItems"
  [maxSize]="isMobile ? 2 : 5"
></app-paginator>
